<ul>
    @for(task of tasks;track $index){
    @let start = $index === 0;
    @let end = $index === (tasks.length - 1);
    <li>
        <svg width="20" height="28" viewBox="0 0 20 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_256_783)">
                @if(!start){
                <path d="M10 5L10 0" [attr.stroke]="getColor(task)" stroke-width="1.5" stroke-linecap="square" />
                }
                <path
                    d="M9.99935 22.3337C14.6017 22.3337 18.3327 18.6027 18.3327 14.0003C18.3327 9.39795 14.6017 5.66699 9.99935 5.66699C5.39698 5.66699 1.66602 9.39795 1.66602 14.0003C1.66602 18.6027 5.39698 22.3337 9.99935 22.3337Z"
                    [attr.stroke]="getColor(task)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                @if(task.status === 'COMPLETED'){
                @defer (on viewport) {
                <path class="completed-check" d="M7.5 13.9997L9.16667 15.6663L12.5 12.333" stroke="#47978B"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                } @placeholder {
                <path />
                }
                }
                @if(task.status === 'ERROR'){
                @defer (on viewport) {
                <path class="error-check" d="M10 18H10.01" stroke="#D7545A" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                <path class="error-check" d="M10 10V14" stroke="#D7545A" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                } @placeholder {
                <path />
                }
                }

                @if(task.status === 'PENDING'){
                @defer (on viewport) {
                <circle [ngClass]="{'pedding-load': task.id}" cx="10" cy="14" r="2" [attr.fill]="getColor(task)" />
                } @placeholder {
                <circle cx="10" cy="14" r="2" />
                }
                }

                @if(!end){
                <path d="M10 28V23" [attr.stroke]="task.status !== 'COMPLETED' ?'#919A96':  getColor(task)"
                    stroke-width="1.5" stroke-linecap="square" />
                }
            </g>
        </svg>
        <p class="task-element">
            @switch (task.type) {
            @case ('UPLOAD') {Envoi vidéo}
            @case ('PROCESSING') {Pré-traitement}
            @case ('TRANSCRIPTION') {Transcription audio}
            @case ('TRANSLATION') {Traduction texte}
            @case ('SUBTITLE_GENERATION') {Génération sous-titres}
            @case ('VOICES_GENERATIONS') {Génération voix}
            @case ('VIDEO_EDITING') {Montage vidéo}
            @default {default}
            }
            <span class="task-id">{{'#' + task.id}}</span>
        </p>
    </li>
    }
</ul>